import { cn } from '#components/utils.js'

const logoSources = {
  dark: '/mono-logo-dark.svg',
  light: '/mono-logo-light.svg',
}

export function Logo({ className, variant = 'dark' }) {
  return (
    <img
      alt='mono.fm'
      className={cn('h-7 w-auto', className)}
      height='28'
      src={logoSources[variant]}
      width='140'
    />
  )
}
